module.exports = __webpack_public_path__ + "img/header-diamondJewelry.c0dcf2f.webp";